<template>
  <div class="integral-panel"
    :style="panelStyle"
    @touchstart.passive="onTouchStart"
    @touchend.passive="onTouchEnd"
  >
    <!-- <Empty /> -->
    <div class="panel-header" ref="panelHeader">
      <div class="contentTab">
        <div
          :class="['menus', { active: active == item.groupValue }]"
          @click="menusHandle(item.groupValue)"
          v-for="(item, key) in menus"
          :key="key"
        >
          {{ item.groupText }}
        </div>
      </div>
    </div>
    <div class="panel-content" ref="panelContent">
      <div v-if="loading" class="loading-wrap">
        <van-loading type="spinner" color="#F80000" />
      </div>
      <template v-else>
        <Group :groupData="groupData" v-if="active == 1" />
        <Scoreboard v-else :outData="outData" />
        <Out v-if="active == 3" :outData="outData" />
      </template>
    </div>


    
  </div>
</template>

<script>
import { getTeamStatList } from "@/service/Integral";
import { getMatchList } from "@/service/Schedule";
import Group from "./components/Group";
import Out from "./components/Out";
import Scoreboard from "./components/Scoreboard";
import { defaultGroupText, groupTypeList } from "@/utils/filedList";
import { Loading } from "vant";
import { mapState } from "vuex";
//import Empty from '@/components/empty.vue';
import { getLang } from '@/utils/lng'

export default {
  name: "Integral",
  components: {
    Group,
    Scoreboard,
    Out,
    //Empty,
    [Loading.name]: Loading,
  },
  data() {
    return {
      menus: [
        { groupValue: 1, groupText: groupTypeList[7][this.getLocal()] },
        { groupValue: 2, groupText: groupTypeList[8][this.getLocal()] },
      ],
      loading: true,
      active: 1,
      groupData: [],
      outData: { n16: [], n8: [], n4: [], n2: [], n1: {} },
      playerData: [],
      fetchTimer: null,
      // ---- 浮动面板 ----
      translateY: 313,
      isDragging: false,
      maxTranslateY: 0,
    };
  },
  created() {
    Promise.all([this.getTeamStatList(), this.getMatchList()]).finally(() => {
      setTimeout(() => {
        this.loading = false;
      }, 300);
    });
    this.startQueue();
  },
  mounted() {
    this.$nextTick(() => {
      const parent = this.$el.parentElement;
      if (parent) {
        const parentTop = parent.getBoundingClientRect().top;
        this.maxTranslateY = parentTop - 44;
      } else {
        this.maxTranslateY = 313;
      }
      this.translateY = this.maxTranslateY;
      this.$el.addEventListener('touchmove', this.onTouchMove, { passive: false });
    });
  },
  destroyed() {
    clearInterval(this.fetchTimer);
    this.fetchTimer = null;
    if (this.$el) {
      this.$el.removeEventListener('touchmove', this.onTouchMove);
    }
  },
  computed: {
    panelStyle() {
      return {
        transform: `translateY(${this.translateY}px)`,
        transition: this.isDragging ? 'none' : 'none',
      };
    },
    expanded() {
      return this.translateY <= 0;
    },
    languageType() {
      return this.common.languageType;
    },
    ...mapState(["common"]),
  },
  methods: {
    // ---- 面板拖拽 ----
    onTouchStart(e) {
      this._startX = e.touches[0].clientX;
      this._startY = e.touches[0].clientY;
      this._startTranslateY = this.translateY;
      this._startContentScrollTop = this.$refs.panelContent?.scrollTop || 0;
      this.isDragging = true;
      this._draggingPanel = false;
      this._directionLocked = false;
      this._isHorizontal = false;
      document.body.style.overflow = 'hidden';
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const deltaX = currentX - this._startX;
      const deltaY = currentY - this._startY;

      // 首次移动时锁定方向：横向滑动则跳过面板逻辑
      if (!this._directionLocked) {
        if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
          this._directionLocked = true;
          this._isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        } else {
          return;
        }
      }
      if (this._isHorizontal) return;

      const contentEl = this.$refs.panelContent;

      // 面板未展开 → 拖拽面板
      if (this._startTranslateY > 0) {
        e.preventDefault();
        this._draggingPanel = true;
        const newY = this._startTranslateY + deltaY;
        this.translateY = Math.max(0, Math.min(this.maxTranslateY, newY));
        return;
      }

      // 面板已展开，在内容顶部向下拖 → 收起面板
      if (this._startContentScrollTop <= 0 && deltaY > 0) {
        if (!this._draggingPanel && contentEl.scrollTop <= 0) {
          this._draggingPanel = true;
        }
        if (this._draggingPanel) {
          e.preventDefault();
          this.translateY = Math.max(0, Math.min(this.maxTranslateY, deltaY));
          return;
        }
      }
      // 其他情况: 正常滚动内容，不 preventDefault
    },
    onTouchEnd(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      document.body.style.overflow = '';
      const deltaY = e.changedTouches[0].clientY - this._startY;
      if (deltaY > 0) {
        // 向下滑 → 想收起
        if (this.translateY > this.maxTranslateY * 0.1) {
          this.translateY = this.maxTranslateY;
        } else {
          this.translateY = 0;
        }
      } else {
        // 向上滑 → 想展开
        if (this.translateY > this.maxTranslateY * 0.9) {
          this.translateY = this.maxTranslateY;
        } else {
          this.translateY = 0;
        }
      }
    },
    // ---- 业务逻辑 ----
    menusHandle(val) {
      this.active = val;
    },
    startQueue() {
      if (this.fetchTimer) {
        clearInterval(this.fetchTimer);
        this.fetchTimer = null;
      }
      this.fetchTimer = setInterval(() => {
        this.getTeamStatList();
        this.getMatchList();
      }, 5000);
    },
    buildData(data) {
      let groupDataTemp = {};
      data.forEach((item) => {
        if (item.ph == 7) {
          groupDataTemp[item.sph] = groupDataTemp[item.sph] || [];
          groupDataTemp[item.sph].push(item);
        }
      });
      this.groupData = Object.keys(groupDataTemp)
        .map((key) => groupDataTemp[key])
        .sort((curr, next) => curr[0].sph - next[0].sph);

      const thirdGroup = this.groupData
        .map((item) => {
          if (item.length && item[2]) {
            return { ...item[2], thirdGroup: true };
          }
        })
        .sort((item, next) => {
          return item.tpr - next.tpr;
        });
      if (thirdGroup.length) {
        this.groupData = [...this.groupData, thirdGroup];
      }
    },
    getTeamStatList() {
      return getTeamStatList({ languageType: getLang(this.languageType) }).then((res) => {
        if (res.success) {
          this.buildData(res.data);
        }
      });
    },
    getMatchList() {
      return getMatchList({ languageType: getLang(this.languageType) }).then((res) => {
        if (res.success) {
          this.buildOutData(res.data);
        }
      });
    },
    buildOutData(data) {
      // 獲取所有淘汰賽列表
      const dataFilter = data
        .filter((item) => item.ph == 8)
        .sort((curr, next) => curr.or - next.or);
      let outData = {
        n16: [],
        n8: [],
        n4: [],
        n2: [],
        n1: {},
      };

      dataFilter.forEach((item) => {
        if (item.ph != 8) return;

        switch (item.sph) {
          case 58:
            outData.n16.push(item);
            break;
          case 9:
            outData.n8.push(item);
            break;
          case 10:
            outData.n4.push(item);
            break;
          case 11:
            outData.n2.push(item);
            break;
          case 12:
            outData.n3 = item;
            break;
          case 13:
            outData.n1 = item;
            break;
        }
      });

      outData.n8.forEach((currItem, index) => {
        if (!currItem.tms || currItem.tms.length == 0) {
          currItem.tms = [
            { na: defaultGroupText.n8[index][0] },
            { na: defaultGroupText.n8[index][1] },
          ];
        }
      });

      console.log('[outData]', outData)

      this.outData = outData;
    },
  },
};
</script>

<style lang="scss" scoped>
.integral-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(100dvh - 44px);
  display: flex;
  flex-direction: column;
  background: var(--color-5);
  border-radius: 20px 20px 0 0;
  z-index: 10;
  will-change: transform;
}

.panel-header {
  flex-shrink: 0;
  user-select: none;
}

.contentTab {
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  background: var(--color-10);
  border-radius: 20px 20px 0 0;
  .menus {
    height: 28px;
    line-height: 28px;
    flex: 1;
    text-align: center;
    background: var(--color-11);
    font-size: 14px;
    color: var(--text-dark-color);
    &:first-child {
      border-radius: 100px 0 0 100px;
    }
    &:last-child {
      border-radius: 0 100px 100px 0;
    }
  }
  .active {
    background: #F80000;
    color: #fff;
  }
}

.panel-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-bottom: 80px;

  .loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
  }
}
</style>

<style lang="scss">
.dark {
  .integral-panel {
    .contentTab {
      background: var(--color-10);
      .menus {
        &.active {
          background: #F80000;
          color: #fff;
        }
      }
    }
  }
}
</style>